import React from "react";
import Tag from "../../components/Tag";
import { STATUS_LABEL, STATUS_TONE } from "../data";

/* ---------- Booking status badge (wraps the shared Tag) ---------- */

export default function StatusBadge({ status }) {
  return (
    <Tag tone={STATUS_TONE[status] || "muted"} size={11} upper>
      {STATUS_LABEL[status] || status}
    </Tag>
  );
}
